import config from '@/env';
export default {
  bind: (el, binding) => {
    if (!config.isAutomationTestsEnabled) {
      return;
    }
    el.dataset['testLocator'] = binding.value;
  },
};
